var exports = {
  "kL": "ChannelAppearanceTab.module__container___TmNNLX",
  "p$": "ChannelAppearanceTab.module__emptyState___TmNNLX",
  "aK": "ChannelAppearanceTab.module__hint___TmNNLX",
  "tD": "ChannelAppearanceTab.module__blockedList___TmNNLX",
  "bV": "ChannelAppearanceTab.module__cssEditor___TmNNLX",
  "KY": "ChannelAppearanceTab.module__actionBar___TmNNLX",
  "zN": "ChannelAppearanceTab.module__controlGroup___TmNNLX",
  "NI": "ChannelAppearanceTab.module__accentControls___TmNNLX",
  "e1": "ChannelAppearanceTab.module__brightnessRow___TmNNLX",
  "Oe": "ChannelAppearanceTab.module__brightnessLabel___TmNNLX",
  "dB": "ChannelAppearanceTab.module__brightnessHint___TmNNLX",
};

module.exports = exports;
